import moment from "moment";
import axios from "axios";

var dateOnly = " DD/MM/YYYY";
var timeOnly = " HH:mm";

var dateTime = " DD/MM/YYYY HH:mm";
const fullDateTime = "DD/MM/YYYY\u00A0\u00A0\u00A0hh:mm:ss A";

export const REACT_APP_IS_RESULT = window?.env?.REACT_APP_IS_RESULT || false;
export const API_URL = window?.env?.REACT_APP_API_URL;
export const ENTRA_CLIENT_ID = window?.env?.REACT_APP_ENTRA_CLIENT_ID;
export const ENTRA_AUTHORITY = window?.env?.REACT_APP_ENTRA_AUTHORITY;
export const ENTRA_REDIRECT_URI = window?.env?.REACT_APP_ENTRA_REDIRECT_URI;
export const ENTRA_POST_LOGOUT_REDIRECT_URI = window?.env?.REACT_APP_ENTRA_POST_LOGOUT_REDIRECT_URI;
export const ENTRA_SCOPES = window?.env?.REACT_APP_ENTRA_SCOPES;
export const APP_TYPE = window?.env?.REACT_APP_TYPE;
export const REACT_APP_VERSION = window?.env?.REACT_APP_VERSION;

export function setTimeToMidnightUTC(dateString) {
    const d = new Date(dateString);

    // Get the local year-month-day
    const year = d.getFullYear();
    const month = d.getMonth();     // 0-11
    const day = d.getDate();        // Local calendar day

    // Create a new date at midnight UTC for that local date
    const utcMidnight = new Date(Date.UTC(year, month, day, 0, 0, 0));

    return utcMidnight.toISOString();
}

// Example:
console.log(setTimeToMidnightUTC("2025-12-07T22:00:00.000Z"));
// → "2025-12-07T00:00:00.000Z"

export const EntraDeviceIDSecretKey = 'mySecretKey';

export function maskMiddle(str) {
    if(str == null) return "";
    if (str.length <= 6) return str; // not enough characters to mask
    return str.slice(0, 4) + "*".repeat(str.length - 6) + str.slice(-2);
}

export function formatDate(date) {
    if (date == null) {
        return ""
    }

    return moment(date).format(dateOnly);
}

export function getMomentTime(date) {
    return moment(date).format(timeOnly);
}

export function formatDateTime(date) {
    if (date == null) {
        return ""
    }

    return moment(date).format(dateTime);
}

export function formatDateTimeSeconds(date) {
    if (date == null) {
        return "";
    }

    return moment(date).format(fullDateTime);
}

export function headers() {
    var token = JSON.parse(localStorage.getItem("token"));

    if (token) {
        axios.defaults.headers.common['Content-Type'] = 'application/json'
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + token.idToken;
    }
}
